<template>
  <div v-if="isUser" class="pt-24">
    <suspense>
      <se-advisor-advisors-list :query="{ sort: 'rankings_desc' }" :has-paging="true">
        <template #title>
          <h1 class="text-h-l md:text-h-2xl font-semibold">Top {{ config.advisors }}</h1>
        </template>
      </se-advisor-advisors-list>
    </suspense>
  </div>
  <se-advisor-dashboard v-if="isAdvisor" />
</template>

<script lang="ts" setup>
import SeAdvisorAdvisorsList from '@/src/modules/advisor/components/advisors-list.vue';
import SeAdvisorDashboard from '@/src/modules/dashboard/views/advisor-dashboard.vue';
import { useGlobalProperties } from '@/src/composables/useGlobalProperties';
import { usersStore } from '@/src/store/users';
import { theme } from '@/theme';
import { storeToRefs } from 'pinia';

const config = theme.general;
const { isAdvisor, isUser, isAdmin, isSupport } = storeToRefs(usersStore());
const { getGlobalProperties } = useGlobalProperties();
const { $router } = getGlobalProperties();

if (isAdmin.value || isSupport.value) {
  // When sign in this page is opened for all users, opening correct one for admin.
  $router.push('/admin-dashboard/users');
}
</script>
